import { Feature } from "ol";
import { Circle as CircleStyle, Fill, Stroke, Style, Text } from "ol/style";
import { LineString, MultiPoint, Polygon } from "ol/geom";
import { DrawType } from "./enums";

const white = [255, 255, 255, 1];
const blue = [0, 153, 255, 1];
const blueFill = [0, 153, 255, 0.3];
const orange = [250, 140, 35, 1];
const orangeFill = [250, 140, 35, 0.15];
const primaryDark = "#4c4c4c";
const yellow = [255, 255, 0, 0.8];
const yellowFill = [255, 255, 0, 0.15];

const vertice = new CircleStyle({
    radius: 6,
    fill: new Fill({
        color: blue
    }),
    stroke: new Stroke({
        color: white,
        width: 1.5
    })
});

const strokeStyle = new Stroke({
    color: orange,
    width: 3
});

const selectStrokeStyle = new Stroke({
    color: blue,
    width: 3
});

const highLightStrokeStyle = new Stroke({
    color: yellow,
    width: 3
});

export const getDrawingSymbol = (type: DrawType, isSelect?: boolean, isModify?: boolean): Style | Style[] => {
    if (type === DrawType.Polygon) {
        if (isModify) {
            return new Style({
                image: vertice
            });
        }
        if (isSelect) {
            return [
                new Style({
                    fill: new Fill({
                        color: blueFill
                    }),
                    stroke: selectStrokeStyle
                }),
                new Style({
                    image: vertice,
                    geometry: (feature) => new MultiPoint((feature.getGeometry() as Polygon).getCoordinates()[0])
                })
            ];
        }
        return new Style({
            fill: new Fill({
                color: orangeFill
            }),
            stroke: strokeStyle
        });
    } else if (type === DrawType.Polyline) {
        if (isModify) {
            return new Style({
                image: vertice
            });
        }
        if (isSelect) {
            return [
                new Style({
                    stroke: selectStrokeStyle
                }),
                new Style({
                    image: vertice,
                    geometry: (feature) => new MultiPoint((feature.getGeometry() as LineString).getCoordinates())
                })
            ];
        }
        return new Style({
            stroke: strokeStyle
        });
    } else {
        return new Style({
            image: new CircleStyle({
                fill: new Fill({
                    color: white
                }),
                stroke: new Stroke({
                    color: isModify ? blue : isSelect ? blue : orange,
                    width: isModify ? 2 : 3
                }),
                radius: 12
            }),
            text: new Text({
                font: 'normal normal 400 20px "icomoon"',
                fill: new Fill({
                    color: isModify ? blue : primaryDark
                }),
                text:
                    type === DrawType.PointCarPark
                        ? String.fromCodePoint(0xe911) // the value of the CSS 'content' property (\ replaced with 0x)
                        : type === DrawType.PointInfra
                        ? String.fromCodePoint(0xe90f) // Infra
                        : type === DrawType.PointTent
                        ? String.fromCodePoint(0xe90e) // Tent
                        : type === DrawType.PointGathering
                        ? String.fromCodePoint(0xe90c) // Gathering
                        : type === DrawType.PointOther
                        ? String.fromCodePoint(0xe90a) // Other
                        : null
            })
        });
    }
};

export const getHighLightSymbol = (feature: Feature): Style => {
    const type = feature.getGeometry().getType();
    const isNaturalRoad = feature.get("ROADSUBTYPE") === 1;

    if (type === "Polygon") {
        return new Style({
            fill: new Fill({
                color: yellowFill
            }),
            stroke: highLightStrokeStyle
        });
    } else if (type === "LineString") {
        return new Style({
            stroke: new Stroke({
                color: yellow,
                width: 5,
                lineDash: isNaturalRoad && [4, 4]
            })
        });
    } else if (type === "Point") {
        return new Style({
            image: new CircleStyle({
                fill: new Fill({
                    color: white
                }),
                stroke: new Stroke({
                    color: yellow,
                    width: 2
                }),
                radius: 12
            })
        });
    }
};
